export const removeNonNumericCharacters = (value: string) => {
  return value.replace(/[^0-9]/g, '')
}

export const parseInteger = (value) => {
  return value.replace(/\D/g, '')
}
